<template>
  <main>
    <!-- <div class="component-featured-collection" :style="{backgroundImage: 'url(http://cdn.sabacell.net/b68514491cad4ebdaaddf1659ac61d47.jpg?h=500)'}"> -->
    <div
      class="component-featured-collection"
      :style="{backgroundImage: 'url(' + fileUrl(collection.banner+'?h=400') + ')'}"
    >
      <div class="image-shadow col px-sm-4 px-1">
        <section
          class="d-flex flex-column justify-content-sm-center align-items-lg-start align-items-sm-center"
        >
          <h1 class="text-white mx-5">{{ collection.name }}</h1>
          <p
            class="lead text-light col-xxs-12 col-sm-8 col-md-6 mt-5 mx-sm-5 mx-1 ps-0 px-md-0 px-sm-5 px-1"
          >{{ collection.description }}</p>
        </section>
      </div>
    </div>
    <article>
      <!-- <section class="mt-3 mb-1 mx-3">
        <b-link class="text-info m-2 btn bg-info text-light">{{$t('collection.sorting.new')}}</b-link>
        <b-link class="text-info m-2">{{$t('collection.sorting.mostVisited')}}</b-link>
        <b-link class="text-info m-2">{{$t('collection.sorting.highestRated')}}</b-link>
      </section>-->
      <ProductListWithoutCarousel :products="collectionProducts" />

      <b-button
        v-if="collection.products.length !== collection.totalProductsCount"
        variant="primary"
        class="d-flex justify-content-center col-md-3 col-sm-6 col-xxs-12 mb-3 mx-auto"
        @click="loadMore"
      >{{ $t('collection.showMore') }}
      <img src="@/assets/loading.svg" height="25" class="px-2" v-if="isLoading"/>
      </b-button>
    </article>
  </main>
</template>

<script>
import ProductListWithoutCarousel from '@/components/ProductListWithoutCarousel.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'GameCollectionDetail',
  components: {
    ProductListWithoutCarousel
  },
  data() {
    return {
      bottomOfWindow: false,
      loadMoreClicked: false,
      isLoading: false
    }
  },
  props: {
    collection: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({
      fileUrl: 'cdn/fileUrl'
    }),
    collectionProducts() {
      return this.collection.products.map(value => {
        return {
          title: value.name,
          imageUrl: value.icon,
          publisher: value.publisher ? value.publisher.name : '',
          targetUrl: '/product/' + value.id,
          genre: value.genres
            .map(g => {
              return g.name
            })
            .join(', ')
        }
      })
    }
  },
  methods: {
    ...mapActions({
      loadCollectionProducts: 'productCatalog/loadCollectionProducts'
    }),
    loadMore() {
      this.isLoading = true
      this.loadCollectionProducts(this.collection.id)
      this.bottomOfWindow =
        document.documentElement.scrollTop + window.innerHeight ===
        document.documentElement.offsetHeight
      window.onscroll = () => {
        if (this.bottomOfWindow && this.loadMoreClicked) {
          this.loadCollectionProducts(this.collection.id)
          this.isLoading = false
          }
      }
      this.loadMoreClicked = true
    }
  }
}
</script>
